__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-user-alerts/v3_0_2/";